const components = require.context('../components/', true, /\.vue$/i)
const pages = require.context('../pages/', true, /\.vue$/i)

const register = (path, component) =>
    Vue.component(
        path
            .split('/')
            .pop()
            .split('.')[0],
        component
    )

components.keys().map(path => register(path, components(path).default))
pages.keys().map(path => register(path, pages(path).default))
